module.exports = __webpack_public_path__ + "img/pasture_andropogon_middle.f7c661fc.webp";